import { render, staticRenderFns } from "./HeroesFull.vue?vue&type=template&id=754c19af&"
import script from "./HeroesFull.vue?vue&type=script&lang=js&"
export * from "./HeroesFull.vue?vue&type=script&lang=js&"
import style0 from "./HeroesFull.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports